import PropTypes from "prop-types"
import { Router as ReachRouter } from "@reach/router"
import HardReload from "components/ui/HardReload"

const Router = ({ children, basePath, primary = true }) => {
  const routerBasePath = basePath || window.routerBasePath

  // https://reach.tech/router/api/Router
  // basepath: Path to base all relative paths to
  // primary: Mange focus on location transitions, If false, focus will not be managed.  Useful for asides, headers, breadcrumbs, etc.

  return (
    <ReachRouter basepath={routerBasePath} primary={primary}>
      {children}

      {/* If no React Routes above are found, try and hard reload */}
      <HardReload default />
    </ReachRouter>
  )
}

Router.propTypes = {
  children: PropTypes.node.isRequired,
  basePath: PropTypes.string,
  primary: PropTypes.bool
}

export default Router
